import { Component, OnInit, OnDestroy } from '@angular/core';
import {ExplorerItem, TreeNodeInfo} from "@catui/types";
import {ProjectService} from "@catcore/services";
import {Router} from "@angular/router";
import {isNullOrUndefined} from "util";
import {Project} from "@catcore/types/api-v2";
import {TestRackService} from "@catmodules/models/test-rack/services/test-rack.service";

@Component({
  selector: 'catapp-test-rack',
  templateUrl: './test-rack.component.html',
  styleUrls: ['./test-rack.component.scss']
})
export class TestRackComponent implements OnInit, OnDestroy {
  doAllowCreate = false;
  activeItem = false;
  explorerItems: ExplorerItem[] = [];
  subscription = null;

  constructor(private projectService: ProjectService,
              private router: Router,
              private testRackService: TestRackService) {
  }

  navigateTo(node: TreeNodeInfo) {
    this.router.navigate(node.item.value.route);

  }

  ngOnInit() {
    this.subscription = this.projectService
      .getCurrentProject()
      .subscribe((project: Project) => {
        if (!isNullOrUndefined(project)) {
          this.explorerItems = [];
          this.explorerItems.push(buildDefaultExplorerItem(project, 'Setup', 'setup'));
          this.explorerItems.push(buildDefaultExplorerItem(project, 'Units', 'units'));
          this.explorerItems.push(buildDefaultExplorerItem(project, 'Patch Field', 'patch-field'));
        }
      });
    this.testRackService.setActive();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.testRackService.setInactive();
  }
}

const buildDefaultExplorerItem = (project: Project, displayName: string, targetRef: string): ExplorerItem => {
  return {label: displayName, value: {route: ['projects', `${project.id}`, 'test-rack', targetRef]}, expanded: false, allowedActions: []};
};




// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/components/test-rack/test-rack.component.ts